import { ReportInstance } from 'domain/entity/reportInstance';
import { GetUseCase } from 'use-case/genericUseCase';
import readReportInstancesUseCase from 'use-case/reportsInstances/read/readReportsInstancesUseCase';
import createDependencyContext from 'adapter/in/common/dependenciesContext';
import readReportInstancesApiClient, { ReadReportInstancesCriteria } from 'adapter/out/client/reportInstances/readReportInstancesApiClient';
import getDashboardsUseCase, { GetDashboards } from 'use-case/dashboards/get/getDashboardsUseCase';
import getDashboardsApiClient from 'adapter/out/client/dashboards/getDashboardsApiClient';
import createDashboardUseCase, { CreateDashboard } from 'use-case/dashboard/create/createDashboardUseCase';
import createDashboardApiClient from 'adapter/out/client/dashboard/createDashboardApiClient';
import readLayoutsApiClient from 'adapter/out/client/layout/readLayoutsApiClient';
import readLayoutsUseCase from 'use-case/layout/read/readLayoutsUseCase';
import Layout from 'domain/entity/layout';
import ReadLayoutsCriteria from 'use-case/layout/read/readLayoutsCriteria';
import createReportInstanceUseCase, { CreateReportInstance } from 'use-case/reportInstance/create/createReportInstanceUseCase';
import createReportInstanceApiClient from 'adapter/out/client/reportInstance/createReportInstanceApiClient';
import getDashboardUseCase, { GetDashboard } from 'use-case/dashboard/get/getDashboardUseCase';
import getDashboardApiClient from 'adapter/out/client/dashboard/getDashboardApiClient';
import readWidgetDataUseCase from 'use-case/widgets/data/read/readWidgetDataUseCase';
import readWidgetDataApiClient from 'adapter/out/client/widgets/data/readWidgetDataApiClient';
import ReadReportInstanceCriteria from 'use-case/reportInstance/read/readReportInstanceCriteria';
import readReportInstanceUseCase from 'use-case/reportInstance/read/readReportInstanceUseCase';
import readReportInstanceApiClient from 'adapter/out/client/reportInstance/readReportInstanceApiClient';
import {
    UpdateDashboardAccess,
    UpdateDashboardFrame,
    UpdateDashboardName,
    UpdateDashboardStar,
    updateDashboardAccessUseCase,
    updateDashboardFrameUseCase,
    updateDashboardNameUseCase,
    updateDashboardStarUseCase,
} from 'use-case/dashboard/update/updateDashboardUseCase';
import updateDashboardNameApiClient from 'adapter/out/client/dashboard/updateDashboardNameApiClient';
import User from 'domain/entity/user';
import Location from 'domain/entity/location';
import readUsersUseCase from 'use-case/users/read/readUsersUseCase';
import readUsersApiClient from 'adapter/out/client/users/read/readUsersApiClient';
import UpdateLayoutCriteria from 'use-case/layout/update/updateLayoutCriteria';
import updateLayoutUseCase from 'use-case/layout/update/updateLayoutUseCase';
import updateLayoutApiClient from 'adapter/out/client/layout/updateLayoutApiClient';
import { IWidgetDataCriteriaDependencies, IWidgetDataDependencies, getCriteriaDestination } from 'adapter/in/common/commonDependencies';
import { ReadWidgetDataCriteriaBuilder, WidgetDataProxyContext } from 'use-case/widgets/data/read/readWidgetDataCriteria';
import { WidgetType } from 'domain/entity/widget';
import deleteDashboardUseCase, { DeleteDashboard } from 'use-case/dashboard/delete/deleteDashboardUseCase';
import deleteDashboardApiClient from 'adapter/out/client/dashboard/deleteDashboardApiClient';
import duplicateDashboardUseCase, { DuplicateDashboard } from 'use-case/dashboard/duplicate/duplicateDashboardUseCase';
import duplicateDashboardApiClient from 'adapter/out/client/dashboard/duplicateDashboardApiClient';
import deleteDashboardAnalysisUseCase, {
    DeleteDashboardAnalysis,
} from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisUseCase';
import deleteDashboardAnalysisApiClient from 'adapter/out/client/analysis/deleteDashboardAnalysisApiClient';
import updateDashboardStarApiClient from 'adapter/out/client/dashboard/updateDashboardStarApiClient';
import { Automation } from 'domain/entity/automation';
import getReadAutomationsUseCase from 'use-case/automations/read/readAutomationsUseCase';
import readAutomationsApiClient, { ReadAutomationsCriteria } from 'adapter/out/client/automations/readAutomationsApiClient';
import getDeleteAutomationUseCase from 'use-case/automation/delete/deleteAutomationUseCase';
import deleteAutomationApiClient from 'adapter/out/client/automation/deleteAutomationApiClient';
import ReadLocationsByHierarchyCriteria from 'use-case/locations/read/ReadLocationsByHierarchyCriteria';
import readLocationsApiClient from 'adapter/out/client/locations/readLocationsByHierarchyApiClient';
import readLocationsUsecase from 'use-case/locations/read/ReadLocationsByHierarchyUseCase';
import { CreateOrPreviewAutomationCriteria } from 'use-case/automation/create/createAutomationCriteria';
import createAutomationApiClient from 'adapter/out/client/automation/createAutomationApiClient';
import getCreateAutomationsUseCase from 'use-case/automation/create/createAutomationUseCase';
import getSimulateReportsUseCase from 'use-case/reportSimulation/simulate/simulateReportsUseCase';
import simulateAutomationApiClient from 'adapter/out/client/reportSimulation/simulateReportsApiClient';
import { ReportSimulation } from 'domain/entity/reportSimulation';
import DeleteAutomationCriteria from 'use-case/automation/delete/deleteAutomationCriteria';
import { DeleteData } from 'domain/entity/deleteData';
import DeactivateAutomationCriteria from 'use-case/automation/deactivate/deactivateAutomationCriteria';
import deactivateAutomationApiClient from 'adapter/out/client/automation/deactivateAutomationApiClient';
import getDeactivateAutomationUseCase from 'use-case/automation/deactivate/deactivateAutomationUseCase';
import updateDashboardFrameApiClient from 'adapter/out/client/dashboard/updateDashboardFrameApiClient';
import deleteReportInstanceUseCase, { DeleteReportInstance } from 'use-case/reportInstance/delete/deleteReportInstanceUseCase';
import deleteReportInstanceApiClient from 'adapter/out/client/reportInstance/deleteReportInstanceApiClient';
import readProxyWidgetDataApiClient from 'adapter/out/client/widgets/data/proxy/readProxyWidgetDataApiClient';
import readProxyTextBlockDataApiClient from 'adapter/out/client/widgets/data/proxy/readProxyTextBlockDataApiClient';
import readProxyFrameDataApiClient from 'adapter/out/client/widgets/data/proxy/readProxyFrameDataApiClient';
import readProxyWidgetDataRouterClient from 'adapter/out/client/widgets/data/proxy/readProxyWidgetDataRouterClient';
import readTextBlockDataApiClient from 'adapter/out/client/widgets/data/readTextBlockDataApiClient';
import readFrameDataApiClient from 'adapter/out/client/widgets/data/readFrameDataApiClient';
import readWidgetDataRouterClient from 'adapter/out/client/widgets/data/readWidgetDataRouterClient';
import updateDashboardAccessApiClient from 'adapter/out/client/dashboard/updateDashboardAccessApiClient';
import readLogosUseCase from 'use-case/logos/read/readLogosUseCase';
import readLogosApiClient from 'adapter/out/client/logos/readLogosApiClient';
import Logo from 'domain/entity/logo';
import readFeatureFlagApiClient from 'adapter/out/client/featureFlags/readFeatureFlagApiClient';
import readFeatureFlagUseCase, { ReadFeatureFlag } from 'use-case/featureFlags/read/readFeatureFlagUseCase';

export interface IReportsDependencies {
    getReportTemplates: GetDashboards;
    getReportInstances: GetUseCase<ReportInstance[], ReadReportInstancesCriteria>;
    createReportTemplate: CreateDashboard;
    createReportInstance: CreateReportInstance;
    deleteReportInstance: DeleteReportInstance;
    getUpdateStarReportTemplate: UpdateDashboardStar;
    readLogos: GetUseCase<Logo[], null>;
    getAutomations: GetUseCase<Automation[], ReadAutomationsCriteria>;
}

export interface IReportTemplateDependencies {
    getLayouts: GetUseCase<Layout[], ReadLayoutsCriteria>;
    createReportInstance: CreateReportInstance;
    getReportTemplate: GetDashboard;
    renameReportTemplate: UpdateDashboardName;
    getUpdateFrameReportTemplate: UpdateDashboardFrame;
    getUsers: GetUseCase<User[], null>;
    updateTemplateLayout: GetUseCase<Layout, UpdateLayoutCriteria>;
    deleteReportTemplate: DeleteDashboard;
    deleteReportAnalysis: DeleteDashboardAnalysis;
}

export interface IReportTemplateActionDependencies {
    deleteReportTemplate: DeleteDashboard;
    duplicateReportTemplate: DuplicateDashboard;
    updateDashboardAccess: UpdateDashboardAccess;
}

export interface IReportInstanceDependencies {
    getLayouts: GetUseCase<Layout[], ReadLayoutsCriteria>;
    getReportInstance: GetUseCase<ReportInstance, ReadReportInstanceCriteria>;
}

export interface IAutomationDependencies {
    getReportTemplates: GetDashboards;
    getUsers: GetUseCase<User[], null>;
    getLocations: GetUseCase<Location, ReadLocationsByHierarchyCriteria>;
    createAutomation: GetUseCase<Automation, CreateOrPreviewAutomationCriteria>;
    deleteAutomation: GetUseCase<DeleteData, DeleteAutomationCriteria>;
    deactivateAutomation: GetUseCase<DeleteData, DeactivateAutomationCriteria>;
    simulateReports: GetUseCase<ReportSimulation[], CreateOrPreviewAutomationCriteria>;
    readFeatureFlag: ReadFeatureFlag;
}

const ReportsDependencyContext = createDependencyContext<IReportsDependencies>();

const ReportTemplateDependencyContext = createDependencyContext<IReportTemplateDependencies>();

const ReportInstanceDependencyContext = createDependencyContext<IReportInstanceDependencies>();

const ReportActionDependencyContext = createDependencyContext<IReportTemplateActionDependencies>();

const AutomationDependencyContext = createDependencyContext<IAutomationDependencies>();

export const getReportsDependencies = (fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>, baseUrl: string) => ({
    getReportTemplates: getDashboardsUseCase(getDashboardsApiClient(fetch, baseUrl)),
    getReportInstances: readReportInstancesUseCase(readReportInstancesApiClient(fetch, baseUrl)),
    createReportTemplate: createDashboardUseCase(createDashboardApiClient(fetch, baseUrl)),
    createReportInstance: createReportInstanceUseCase(createReportInstanceApiClient(fetch, baseUrl)),
    deleteReportInstance: deleteReportInstanceUseCase(deleteReportInstanceApiClient(fetch, baseUrl)),
    getUpdateStarReportTemplate: updateDashboardStarUseCase(updateDashboardStarApiClient(fetch, baseUrl)),
    readLogos: readLogosUseCase(readLogosApiClient(fetch, baseUrl)),
    getAutomations: getReadAutomationsUseCase(readAutomationsApiClient(fetch, baseUrl)),
});

export const getAutomationDependencies = (fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>, baseUrl: string) => ({
    getReportTemplates: getDashboardsUseCase(getDashboardsApiClient(fetch, baseUrl)),
    getUsers: readUsersUseCase(readUsersApiClient(fetch, baseUrl)),
    getLocations: readLocationsUsecase(readLocationsApiClient(fetch, baseUrl)),
    createAutomation: getCreateAutomationsUseCase(createAutomationApiClient(fetch, baseUrl)),
    deleteAutomation: getDeleteAutomationUseCase(deleteAutomationApiClient(fetch, baseUrl)),
    deactivateAutomation: getDeactivateAutomationUseCase(deactivateAutomationApiClient(fetch, baseUrl)),
    simulateReports: getSimulateReportsUseCase(simulateAutomationApiClient(fetch, baseUrl)),
    readFeatureFlag: readFeatureFlagUseCase(readFeatureFlagApiClient(fetch, baseUrl)),
});

export const getReportTemplateDependencies = (
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
    baseUrl: string
): IReportTemplateDependencies => ({
    getLayouts: readLayoutsUseCase(readLayoutsApiClient(fetch, baseUrl)),
    getReportTemplate: getDashboardUseCase(getDashboardApiClient(fetch, baseUrl)),
    createReportInstance: createReportInstanceUseCase(createReportInstanceApiClient(fetch, baseUrl)),
    getUpdateFrameReportTemplate: updateDashboardFrameUseCase(updateDashboardFrameApiClient(fetch, baseUrl)),
    renameReportTemplate: updateDashboardNameUseCase(updateDashboardNameApiClient(fetch, baseUrl)),
    getUsers: readUsersUseCase(readUsersApiClient(fetch, baseUrl)),
    updateTemplateLayout: updateLayoutUseCase(updateLayoutApiClient(fetch, baseUrl)),
    deleteReportTemplate: deleteDashboardUseCase(deleteDashboardApiClient(fetch, baseUrl)),
    deleteReportAnalysis: deleteDashboardAnalysisUseCase(deleteDashboardAnalysisApiClient(fetch, baseUrl)),
});

export const getReportTemplateActionDependencies = (
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
    baseUrl: string
) => ({
    deleteReportTemplate: deleteDashboardUseCase(deleteDashboardApiClient(fetch, baseUrl)),
    duplicateReportTemplate: duplicateDashboardUseCase(duplicateDashboardApiClient(fetch, baseUrl)),
    updateDashboardAccess: updateDashboardAccessUseCase(updateDashboardAccessApiClient(fetch, baseUrl)),
});

export const getReportInstanceDependencies = (
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
    baseUrl: string
): IReportInstanceDependencies => ({
    getLayouts: readLayoutsUseCase(readLayoutsApiClient(fetch, baseUrl)),
    getReportInstance: readReportInstanceUseCase(readReportInstanceApiClient(fetch, baseUrl)),
});

export const getReportInstanceWidgetDataDependencies = (
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
    baseUrl: string
): IWidgetDataDependencies => {
    const defaultClient = readWidgetDataApiClient(fetch, baseUrl);
    const textBlockClient = readTextBlockDataApiClient(fetch, baseUrl);
    const frameClient = readFrameDataApiClient;
    const widgetDataClient = readWidgetDataRouterClient(frameClient, textBlockClient, defaultClient);
    return {
        readWidgetData: readWidgetDataUseCase(widgetDataClient),
    };
};

export const getReportInstanceWidgetDataCriteriaDependencies = (
    reportInstanceId: string,
    registerWidget: () => () => void,
    triggerWidgetLoads: boolean,
    periodFrom?: string | null,
    periodTo?: string | null
): IWidgetDataCriteriaDependencies => ({
    buildWidgetDataCriteria: (widgetId: string, widgetType: WidgetType, frameText?: string) => {
        const destination = getCriteriaDestination(widgetType);
        const builder = ReadWidgetDataCriteriaBuilder.create()
            .withWidgetId(widgetId)
            .withDestination(destination)
            .withReportInstanceId(reportInstanceId)
            .withFrameText(frameText);
        if (periodFrom) builder.withPeriodFrom(periodFrom);
        if (periodTo) builder.withPeriodTo(periodTo);
        return builder.build();
    },
    registerWidget,
    triggerWidgetLoads,
    reloadKey: JSON.stringify({ reportInstanceId, periodFrom, periodTo }),
});

export const getReportTemplateWidgetDataDependencies = (
    fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
    baseUrl: string
): IWidgetDataDependencies => {
    const defaultClient = readProxyWidgetDataApiClient(fetch, baseUrl);
    const textBlockClient = readProxyTextBlockDataApiClient(fetch, baseUrl);
    const frameClient = readProxyFrameDataApiClient;
    const proxyRouterClient = readProxyWidgetDataRouterClient(frameClient, textBlockClient, defaultClient);
    return {
        readWidgetData: readWidgetDataUseCase(proxyRouterClient),
    };
};

export const getReportTemplateWidgetDataCriteriaDependencies = (
    widgetDataContext: WidgetDataProxyContext
): IWidgetDataCriteriaDependencies => ({
    buildWidgetDataCriteria: (widgetId: string, widgetType: WidgetType, frameText?: string) => {
        const destination = getCriteriaDestination(widgetType);
        return ReadWidgetDataCriteriaBuilder.create()
            .withWidgetId(widgetId)
            .withDestination(destination)
            .withReportTemplateProxyContext(widgetDataContext)
            .withFrameText(frameText)
            .build();
    },
    reloadKey: JSON.stringify(widgetDataContext),
});

export const { Provider: ReportsDependenciesContextProvider, useDependencies: useReportsDependencies } = ReportsDependencyContext;

export const {
    Provider: ReportTemplateDependenciesContextProvider,
    useDependencies: useReportTemplateDependencies,
} = ReportTemplateDependencyContext;

export const {
    Provider: ReportInstanceDependenciesContextProvider,
    useDependencies: useReportInstanceDependencies,
} = ReportInstanceDependencyContext;

export const { Provider: AutomationDependencyContextProvider, useDependencies: useAutomationDependencies } = AutomationDependencyContext;

export const { Provider: ReportActionContextProvider, useDependencies: useReportActionsDependencies } = ReportActionDependencyContext;
